import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import General from './General';
import WorkingHours from './WorkingHours';
import BankingLegal from './BankingLegal';

import { Container } from './styles';

const Settings: FC = () => {
  return (
    <Container>
      <Switch>
        <Route exact path="/settings/general" component={General} />
        <Route exact path="/settings/working-hours" component={WorkingHours} />
        <Route exact path="/settings/banking-legal" component={BankingLegal} />
        <Redirect to="/settings/general" />
      </Switch>
    </Container>
  );
};

export default Settings;
